var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subhead"},[_c('div',{staticClass:"subhead__title"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"subhead__actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }